import styled from "styled-components";
import { IonContent } from "@ionic/react";
import { Card as CardComponent, CardProps } from "../components/Card";
import { cards } from "../assets/cards";
import { useTranslate } from "../contexts/translate";
import { Background } from "../components/ui/Background";
import { CardSubheader } from "../components/CardSubheader";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../components/ui/Header";

const Content = styled(IonContent)`
  --background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export function Card() {
  const { lang } = useTranslate();
  const localizedCards = cards[lang as any] || [];
  const params = useParams<{ type: string; id: string }>();
  const [card, setCard] = useState<CardProps | null>();
  const navigate = useNavigate();

  useEffect(() => {
    const id = params?.id;
    const type = params?.type as string;
    const card =
      id &&
      type &&
      localizedCards.find(
        (c) => c.id === Number(id) && type.startsWith(c.type)
      );
    setCard(card);
  }, [params, localizedCards]);

  const nextCard =
    card &&
    localizedCards
      .slice(localizedCards.indexOf(card) + 1)
      .find((c) => params.type?.startsWith(c.type));
  const prevCard =
    card &&
    localizedCards
      .slice(0, localizedCards.indexOf(card))
      .reverse()
      .find((c) => params.type?.startsWith(c.type));

  function onNavigate(card?: CardProps) {
    if (card) {
      //setCard(card);
      navigate(`/cards/${params.type}/${card?.id}`, { replace: true });
    }
  }

  return (
    <>
      <Header size="small" shouldHide />
      <IonContent>
        <Background background="cards">
          {card && (
            <CardSubheader
              card={card}
              prevCard={prevCard}
              nextCard={nextCard}
              onNavigate={onNavigate}
            ></CardSubheader>
          )}
          <Content fullscreen>
            <Container>
              {card && (
                <CardComponent {...card} key={`${card.type}:${card.id}`} />
              )}
            </Container>
          </Content>
        </Background>
      </IonContent>
    </>
  );
}
